import React from "react";
import toast from "react-hot-toast";
import { markAsCompletedLocally } from "../api/workOrder";

const MarkCompletedConfirmModal = ({
  isOpen,
  onClose,
  workOrder,
  onSuccess,
}) => {
  const [confirmChecked, setConfirmChecked] = React.useState(false);

  if (!isOpen || !workOrder) return null;

  const handleConfirm = async () => {
    if (!confirmChecked) {
      toast.error("Please confirm before proceeding");
      return;
    }

    try {
      const response = await markAsCompletedLocally(workOrder.orderId);

      if (response?.success) {
        toast.success(
          `Work order ${workOrder.woNumber} marked as completed in Planipro!`,
          { duration: 5000, position: "top-right" },
        );
        onSuccess?.();
        onClose();
      }
    } catch (err) {
      const msg = err.response?.data?.error || "Failed to mark work order";
      toast.error(msg, { duration: 6000, position: "top-right" });
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-2xl max-w-md w-full overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-yellow-50 px-6 py-4 border-b border-yellow-200 flex items-center gap-3">
          <span className="text-2xl">⚠️</span>
          <h3 className="text-lg font-bold text-gray-900">
            Mark as Completed in Planipro?
          </h3>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          <p className="text-gray-700 leading-relaxed">
            This will mark work order{" "}
            <strong className="font-semibold">{workOrder.woNumber}</strong> {""}
            as completed <strong>only inside Planipro</strong> so it can move to
            the Transfer tab.
          </p>

          <p className="text-red-700 font-medium">
            Important: This action does <strong>NOT</strong> complete anything
            in ERPAG.
            <br />
            You <strong>must manually complete it in ERPAG</strong> with correct
            materials and lot numbers.
          </p>

          <label className="flex items-start gap-3 cursor-pointer group">
            <input
              type="checkbox"
              checked={confirmChecked}
              onChange={(e) => setConfirmChecked(e.target.checked)}
              className="mt-1 h-5 w-5 rounded border-gray-300 text-yellow-600 focus:ring-yellow-500"
            />
            <span className="text-sm text-gray-700 group-hover:text-gray-900 transition">
              I confirm this is a Planipro-only action and I will complete the
              work order manually in ERPAG.
            </span>
          </label>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-gray-50 border-t flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-5 py-2.5 rounded-lg bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium transition"
          >
            Cancel
          </button>

          <button
            onClick={handleConfirm}
            disabled={!confirmChecked}
            className={`px-6 py-2.5 rounded-lg font-medium text-white transition-all shadow-sm
              ${
                confirmChecked
                  ? "bg-yellow-600 hover:bg-yellow-700 active:bg-yellow-800"
                  : "bg-gray-400 cursor-not-allowed opacity-70"
              }`}
          >
            Confirm & Mark
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarkCompletedConfirmModal;
